


import { configureStore } from '@reduxjs/toolkit';
import { persistStore, persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage'; // Defaults to localStorage for web

import rootReducer from './store/root';
// Persist configuration
const persistConfig = {
    key: 'root', // Key for the persisted state
    storage,     // Storage medium (localStorage in this case)
};

const persistedReducer = persistReducer(persistConfig, rootReducer);
const store = configureStore({
    reducer: persistedReducer,
});
// Create a persistor
const persistor = persistStore(store);

export { store, persistor };